import gql from 'graphql-tag';

export const getDOPLabels = gql`
  query getDOPLabels {
    getDOPLabels {
      id
      labelText
      active
    }
  }
`;
